import {FrontendAccountNotification} from '@shared/models/api_models';

import {createDataStore} from '@shared_web/lib/data_store';
import {notifyError} from '@shared_web/lib/notification';

import {apiCall} from '@mavismart_frontend/lib/api';

const hasUnreadNotificationsStore = createDataStore<boolean | undefined>(undefined);

export const useHasUnreadNotifications = hasUnreadNotificationsStore.useData;
export const setHasUnreadNotifications = (notifications: FrontendAccountNotification[]) =>
  hasUnreadNotificationsStore.setData(notifications.length > 0);
export const clearHasUnreadNotifications = () => hasUnreadNotificationsStore.setData(undefined);
export const fetchHasUnreadNotifications = async () => {
  try {
    const response = await apiCall('POST /list-account-notifications', {
      status: 'unread',
      limit: 1,
    });
    setHasUnreadNotifications(response.notifications);
  } catch (error) {
    notifyError(error);
  }
};
